// Single source of truth for the platform API base URL.
//
// This used to be hardcoded, in fifteen places, as
// `https://software.radiostream.co.za/api/v1`. That host does not run the admin
// API — it runs the instore-player service. Against it:
//
//   POST /api/v1/auth/login   -> 500 {"detail":"An unexpected error occurred"}
//   GET  /api/v1/auth/me      -> 404
//   POST /api/v1/auth/mfa/setup  -> 404
//   POST /api/v1/auth/mfa/verify -> 404
//   GET  /api/v1/tenants|/users|/roles -> 404
//
// That 500 body is, verbatim, the red banner the login form showed: the form was
// faithfully reporting another service's server error. The MFA enrollment payload
// could never arrive, so the enroll step could never open.
//
// The admin API is served by the SAME vhost as this SPA — admin.radiostream.co.za
// proxies /api/v1/... to it. Against that host the same calls behave:
//
//   POST /api/v1/auth/login  -> 401 {"detail":"Invalid email or password"}
//   POST /api/v1/auth/login {} -> 422 (field validation)
//   GET  /api/v1/auth/me, POST /api/v1/auth/mfa/setup, /auth/mfa/verify -> 401
//
// So the base is same-origin and relative by default: it cannot drift onto
// another service, and it needs no CORS preflight. REACT_APP_API_BASE overrides
// it at build time for a build aimed at a different deployment.
const RAW = String(process.env.REACT_APP_API_BASE || '/api/v1').replace(/\/+$/, '');

// Resolved to an absolute URL when a window is available, so that anything
// parsing a URL against this base (see pathOf in api.js) always has a valid base.
const ORIGIN =
  typeof window !== 'undefined' && window.location ? window.location.origin : '';

export const API_BASE = /^https?:\/\//i.test(RAW) ? RAW : `${ORIGIN}${RAW}`;

export default API_BASE;
